import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';

var _createNamespace = createNamespace('pagination'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

function makePage(number, text, active) {
    return {
        number: number,
        text: text,
        active: active
    };
}

var BORDER = 'mai-hairline';
export default {
    name: getComponentName('Pagination'),
    data: function data() {
        return {};
    },
    props: {
        prevText: {
            type: String,
            default: '上一页'
        },
        nextText: {
            type: String,
            default: '下一页'
        },
        forceEllipses: Boolean,
        mode: {
            type: String,
            default: 'multi'
        },
        value: {
            type: Number,
            default: 0
        },
        pageCount: {
            type: [Number, String],
            default: 0
        },
        totalItems: {
            type: [Number, String],
            default: 0
        },
        itemsPerPage: {
            type: [Number, String],
            default: 10
        },
        showPageSize: {
            type: [Number, String],
            default: 5
        }
    },
    computed: {
        count: function count() {
            var count = this.pageCount || Math.ceil(this.totalItems / this.itemsPerPage);
            return Math.max(1, count);
        },
        pages: function pages() {
            var pages = [];
            var pageCount = this.count;
            var showPageSize = +this.showPageSize;

            if (this.mode !== 'multi') {
                return pages;
            }

            var startPage = 1;
            var endPage = pageCount;
            var isMaxSized = showPageSize < pageCount;

            if (isMaxSized) {
                startPage = Math.max(this.value - Math.floor(showPageSize / 2), 1);
                endPage = startPage + showPageSize - 1;

                if (endPage > pageCount) {
                    endPage = pageCount;
                    startPage = endPage - showPageSize + 1;
                }
            }

            for (var number = startPage; number <= endPage; number++) {
                var page = makePage(number, number, number === this.value);
                pages.push(page);
            }

            if (isMaxSized && showPageSize > 0 && this.forceEllipses) {
                if (startPage > 1) {
                    var previousPageSet = makePage(startPage - 1, '...', false);
                    pages.unshift(previousPageSet);
                }

                if (endPage < pageCount) {
                    var nextPageSet = makePage(endPage + 1, '...', false);
                    pages.push(nextPageSet);
                }
            }

            return pages;
        }
    },
    watch: {
        value: {
            handler: function handler(page) {
                this.select(page || this.value);
            },
            immediate: true
        }
    },
    methods: {
        select: function select(page, emitChange) {
            page = Math.min(this.count, Math.max(1, page));

            if (this.value !== page) {
                this.$emit('input', page);

                if (emitChange) {
                    this.$emit('change', page);
                }
            }
        }
    },
    render: function render() {
        var _this = this;

        var h = arguments[0];
        var value = this.value;
        var simple = this.mode !== 'multi';

        var onSelect = function onSelect(value) {
            return function() {
                _this.select(value, true);
            };
        };

        return h(
            'ul',
            {
                class: b({
                    simple: simple
                })
            },
            [
                h(
                    'li',
                    {
                        class: [
                            b('item', {
                                disabled: value === 1
                            }),
                            b('prev'),
                            BORDER
                        ],
                        on: {
                            click: onSelect(value - 1)
                        }
                    },
                    [this.prevText]
                ),
                this.pages.map(function(page, index) {
                    return h(
                        'li',
                        {
                            class: [
                                b('item', {
                                    active: page.active
                                }),
                                b('page'),
                                BORDER
                            ],
                            key: index,
                            on: {
                                click: onSelect(page.number)
                            }
                        },
                        [page.text]
                    );
                }),
                simple &&
                    h(
                        'li',
                        {
                            class: b('page-desc')
                        },
                        [this.$slots.default || ''.concat(value, '/').concat(this.count)]
                    ),
                h(
                    'li',
                    {
                        class: [
                            b('item', {
                                disabled: value === this.count
                            }),
                            b('next'),
                            BORDER
                        ],
                        on: {
                            click: onSelect(value + 1)
                        }
                    },
                    [this.nextText]
                )
            ]
        );
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
